import React, { useEffect } from "react";
import { useStore } from "../../../contexts/store-provider";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import RoutesConstants from "../../../constants/routes.constant";
import {
  getStoreCodeFromLocalStorage,
  getStoreIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../../helpers/localstorage-helper";
import { formatMessage } from "../../../translations/format-message";
import userTypeEnum from "../../../constants/enums/user-type-enum";

interface IProps {
  storeId: number;
  selectedCustomerId: number;
  openCustomerDialogHandler: () => void;
}

const CustomerInfoCard = (props: IProps) => {
  const { customerManagementStore, smrStore } = useStore();
  const {
    customerDetail,
    GetCustomerByIdService,
    resetCustomerDetail,
    addUpdateCustomerState,
    resetAddUpdateCustomerState,
  } = customerManagementStore;
  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateCustomerSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateCustomerState.success) {
      // GetCustomerByIdService(
      //   props.selectedCustomerId,
      //   getUserTypeFromLocalStorage() === userTypeEnum[userTypeEnum.Store]
      //     ? getStoreIdFromLocalStorage()
      //     : null
      // );
      resetAddUpdateCustomerState();
    }
  }, [addUpdateCustomerState.success]);

  useEffect(() => {
    if (props.selectedCustomerId > 0){
      let userTypeFromLocalStorage = getUserTypeFromLocalStorage();
      GetCustomerByIdService(props.selectedCustomerId,
        (userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.SuperAdmin] && userTypeFromLocalStorage !== userTypeEnum[userTypeEnum.HeadQuarter])
          ? props.storeId
          : null);
    }
    return () => {
      resetCustomerDetail();
    };
  }, []);

  return (
    <div>
      <div className="p-3 customer-info-card">
        <p>
          <strong>{formatMessage("customer_name")}:</strong>&nbsp;
          {customerDetail.LastNameKana} {customerDetail.FirstNameKana}
          {/* {customerDetail.LastName && customerDetail.FirstName &&
          `(${customerDetail.LastName} ${customerDetail.FirstName})`
          } */}
          <button
            className="btn btn-primary btn-sm ms-3"
            onClick={() => {
              props.openCustomerDialogHandler();
            }}
          >
            {" "}
            <i className="bi bi-box-arrow-up-right me-1"></i>
            {formatMessage("details")}
          </button>
        </p>
        <p>
          <strong>{formatMessage("email")}:</strong> {customerDetail.Email}
        </p>
        <div className="booking-details">
          <p>
            <strong>{formatMessage("no_of_visit")}:</strong>{" "}
            {getUserTypeFromLocalStorage() ===
            userTypeEnum[userTypeEnum.HeadQuarter] ? "-" : customerDetail.TotalCount?.toString()}
          </p>
          {/* {getUserTypeFromLocalStorage() ===
            userTypeEnum[userTypeEnum.Store] && (
            <p>
              <strong>{formatMessage("store_code")}:</strong>{" "}
              {getStoreCodeFromLocalStorage()}
            </p>
          )} */}
          {customerDetail.DianaCode && (
            <p>
              <strong>{formatMessage("diana_code")}:</strong>{" "}
              {customerDetail.DianaCode}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(CustomerInfoCard);
